import { render, staticRenderFns } from "./PartyManagement.vue?vue&type=template&id=147e4d8d"
import script from "./PartyManagement.vue?vue&type=script&lang=js"
export * from "./PartyManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports